export const slimDataViewScrollbarStyle = {
  scrollbarColor: 'var(--streamlain-v2-layer-blackAlpha-30) transparent',
  scrollbarWidth: 'thin',
  '&::-webkit-scrollbar': { width: '8px', height: '8px' },
  '&::-webkit-scrollbar-thumb': {
    borderRadius: '8px',
    backgroundColor: 'var(--streamlain-v2-layer-blackAlpha-30)',
  },
  '&::-webkit-scrollbar-track': { backgroundColor: 'transparent' },
} as const;
